import { ActionMenuItem, stenaSwitch } from "@stenajs-webui/elements";
import { type FC, Suspense } from "react";

import { fetchSwitchCandidates } from "../../../../../common/api";
import { ErrorBoundary } from "../../../../../common/error-handling/ErrorBoundary";
import { suspend } from "../../../../../vendor/suspend-react";

interface SwitchBookingActionMenuItemProps {
  bookingNo: number;
  onClick: () => void;
}

export const SwitchBookingActionMenuItem: FC<
  SwitchBookingActionMenuItemProps
> = ({ bookingNo, onClick }) => {
  return (
    <ErrorBoundary fallback={() => null}>
      <Suspense
        fallback={
          <ActionMenuItem
            leftIcon={stenaSwitch}
            label={"Switch"}
            disabled
            loading
          />
        }
      >
        <SwitchBookingActionMenuItemLoader
          bookingNo={bookingNo}
          onShowSwitchClick={onClick}
        />
      </Suspense>
    </ErrorBoundary>
  );
};

interface SwitchBookingActionMenuItemLoaderProps {
  bookingNo: number;
  onShowSwitchClick: () => void;
}

const SwitchBookingActionMenuItemLoader = ({
  bookingNo,
  onShowSwitchClick,
}: SwitchBookingActionMenuItemLoaderProps) => {
  const { switchCandidates } = suspend(
    () => fetchSwitchCandidates(bookingNo),
    ["switch-candidates", bookingNo],
  );

  const switchCandidatesExists = (switchCandidates ?? []).length > 0;

  return (
    <ActionMenuItem
      onClick={switchCandidatesExists ? onShowSwitchClick : undefined}
      leftIcon={stenaSwitch}
      label={"Switch"}
      disabled={!switchCandidatesExists}
      title={
        switchCandidatesExists
          ? undefined
          : "No matching bookings to switch with"
      }
    />
  );
};
